import { all, call, put, takeEvery, select } from 'redux-saga/effects'
import { seasonActions } from '@redux/store/index'
import { seasonProductApi, ResType } from '@api'
import { SeasonProductType, SeasonProductBatchUpdateType } from '@schemas'
import type { PayloadAction } from '@reduxjs/toolkit'

// API call to fetch season product
const fetchSeasonProduct = async (seasonId: string): Promise<SeasonProductType[]> => {
	const response = await seasonProductApi.getSeasonProduct({ query: { seasonId } })
	return (response?.data as SeasonProductType[]) || []
}

// API call to batch update season product
const batchUpdateSeasonProduct = async (
	productList: SeasonProductBatchUpdateType[],
): Promise<ResType | undefined> => {
	const response = await seasonProductApi.batchUpdateSeasonProduct({
		body: { productList },
	})
	return response
}

// separate function to handle the fetching logic
function* fetchSeasonProductSaga(action: PayloadAction<string>) {
	try {
		const seasonProducts: SeasonProductType[] = yield call(
			fetchSeasonProduct,
			action.payload,
		)
		yield put(seasonActions.SET_SEASON_PRODUCT_LIST(seasonProducts))
	} catch (error) {
		console.error('Error fetching Season Product:', error)
	}
}

// Saga to handle the batch update action
const batchUpdateSeasonProductSaga = function* (
	action: PayloadAction<SeasonProductBatchUpdateType[]>,
): Generator {
	try {
		yield call(batchUpdateSeasonProduct, action.payload)
		const selectedSeasonId = yield select(state => state.season.selectedSeason?.id)
		if (selectedSeasonId) {
			yield put(seasonActions.FETCH_SEASON_PRODUCT(selectedSeasonId as string))
		}
	} catch (error) {
		console.error('Error batch updating Season Product:', error)
	}
}

// Watcher saga
export function* watchFetchSeasonProduct() {
	yield takeEvery(seasonActions.FETCH_SEASON_PRODUCT.type, fetchSeasonProductSaga)
}

export function* watchBatchUpdateSeasonProduct() {
	yield takeEvery(
		seasonActions.BATCH_UPDATE_SEASON_PRODUCT.type,
		batchUpdateSeasonProductSaga,
	)
}

export default function* seasonProductSaga() {
	yield all([watchFetchSeasonProduct(), watchBatchUpdateSeasonProduct()])
}
